var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "color-input uk-display-inline",
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('div', {
    staticClass: "uk-inline"
  }, [_c('span', {
    staticClass: "uk-form-icon"
  }, [_c('color-preview', {
    staticClass: "color-input__preview",
    attrs: {
      "code": _vm.code,
      "colorful": _vm.colorful
    },
    nativeOn: {
      "click": function($event) {
        _vm.$refs.dropdown.toggle()
      }
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "primaryInput",
    staticClass: "uk-input",
    class: _vm.inputCss,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, function($event) {
        _vm.onInput()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-inline"
  }, [_c('dropdown-button', {
    ref: "dropdown"
  }, [_c('icon', {
    attrs: {
      "name": "paint-bucket"
    },
    slot: "button"
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-form-controls uk-form-controls-text"
  }, [_c('label', {
    staticClass: "uk-form-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickerMode),
      expression: "pickerMode"
    }],
    staticClass: "uk-radio",
    attrs: {
      "type": "radio",
      "value": "compact"
    },
    domProps: {
      "checked": _vm._q(_vm.pickerMode, "compact")
    },
    on: {
      "__c": function($event) {
        _vm.pickerMode = "compact"
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('compact')) + "\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "uk-form-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickerMode),
      expression: "pickerMode"
    }],
    staticClass: "uk-radio",
    attrs: {
      "type": "radio",
      "value": "chrome"
    },
    domProps: {
      "checked": _vm._q(_vm.pickerMode, "chrome")
    },
    on: {
      "__c": function($event) {
        _vm.pickerMode = "chrome"
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('chrome')) + "\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "uk-form-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickerMode),
      expression: "pickerMode"
    }],
    staticClass: "uk-radio",
    attrs: {
      "type": "radio",
      "value": "colorful"
    },
    domProps: {
      "checked": _vm._q(_vm.pickerMode, "colorful")
    },
    on: {
      "__c": function($event) {
        _vm.pickerMode = "colorful"
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('colorful')) + "\n        ")])]), _vm._v(" "), (_vm.showColorPicker) ? _c(_vm.pickerMode, {
    tag: "component",
    staticClass: "color-input__picker uk-margin-top",
    attrs: {
      "value": _vm.pickerData,
      "palette": _vm.colorPalette
    },
    on: {
      "input": _vm.onUpdateColorCode
    }
  }) : _vm._e()], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c52dde2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ColorInput.vue
// module id = 1978
// module chunks = 0